import type { MultipleChoiceInsights } from "@repo/app-types/client/client";
import type { FC } from "react";
import { InsightsTable } from "./insightsTable.js";
import { InsightsCard } from "./keywordTracker/keywordTrackerCardContainer.js";

interface MultipleChoiceSummaryCardProps {
  summary: MultipleChoiceInsights;
}

export const MultipleChoiceSummaryCard: FC<MultipleChoiceSummaryCardProps> = ({
  summary,
}) => {
  const { question, response_count, data } = summary;

  const rowData = data.map((vector) => {
    const percentage =
      vector.response_count > 0
        ? (vector.response_count / response_count) * 100
        : 0;

    return {
      value: vector.name,
      columns: [{ percentage, width: "14%" }],
    };
  });

  return (
    <InsightsCard
      header={
        <div className="flex min-h-[28px] flex-row items-center space-x-1 text-base font-semibold text-foreground">
          {question}
          {` (${summary.response_count} ${
            summary.response_count > 1 ? "responses" : "response"
          })`}
        </div>
      }
      body={<InsightsTable rowData={rowData} />}
    />
  );
};
